import Vue from 'vue';
import Router from 'vue-router';
import Axios from 'axios';
import Configurator from '@/components/Configurator.vue';
import Assembly from '@/components/Assembly.vue';
import RoomConfigurator from '@/components/RoomConfigurator.vue';

import Controller from '@/components/controller/Controller';
import { ConfiguratorDefinition, parse } from '@/models/configuratorx/configuratorSchema';
Vue.use(Router);
import { Store } from '@/store';


interface IWindowConfig{
  textureBaseUrl:string;
  blLogin:string;
  blToken:string;
}

function getWindowConfig() : IWindowConfig {
  return (window as any).config as IWindowConfig;
}

const WindowConfig = getWindowConfig();

export default new Router({

  routes: [
    {
      path: '/',
      name: 'Configurator',
      component: Configurator,
      beforeEnter: (to, from, next) => {
        const configuratorConfigReq = Axios.get('static/data/config.json').then((da) => {
          const Configurator = parse(da.data);

          Store.state.configuratorConfig = {
            ...WindowConfig,
            definitions: Configurator,
          };
          next();
        }).error((ex) => {
          next(ex);
        });
      },
      props: route => ({ familyId: route.query.f, prodcutId: route.query.p, selectionHash: route.query.s, lang: route.query.l, vmode: route.query.v }),
    },
    {
      path: '/Assembly/:productId',
      name: 'Assembly',
      component: Assembly,
      props: (route) => {
        return { productId: route.params.productId || route.query.p, lang: route.query.l };
      },
      beforeEnter: (to, from, next) => {

        const assemblyConfigReq = Axios.get('static/data/assembly.json').then((da) => {
          const d = {
            ...da.data,
            ...WindowConfig,
          };

          Store.state.assemblyConfig = d;
          next();
        }).error((ex) => {
          next(ex);
        });
      },
    },
    {
      path: '/Room',
      name: 'Room',
      component: RoomConfigurator,
      props: route => ({ productId: route.query.p, lang: route.query.l }),
      beforeEnter: (to, from, next) => {
        const config = getWindowConfig();
        const roomConfiguratorConfigReq = Axios.get('static/data/room.json').then((da) => {
          const d = {
            ...da.data,
            ...WindowConfig,
          };
          Store.roomState.roomConfiguratorConfig = d;
          console.log(d);
          next();
        }).error((ex) => {
          next(ex);
        });
        const configuratorConfigReq = Axios.get('static/data/config.json').then((da) => {
          const Configurator = parse(da.data);
          console.log(Configurator);
          Store.state.configuratorConfig = {
            ...WindowConfig,
            definitions: Configurator,
          };
          next();
        }).error((ex) => {
          next(ex);
        });

      },
    },
  ],
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/router/index.ts